import axios from "../shared/axios";

export const getHomeMovies = async () => {
  const endpoints = {
    Trending: "/trending/movie/day",
    Popular: "/movie/popular",
    "Top Rated": "/movie/top_rated",
    Hot: "/trending/movie/day?page=2",
    Upcoming: "/movie/upcoming",
  };

  const responses = await Promise.all(
    Object.values(endpoints).map((endpoint) => axios.get(endpoint))
  );

  const data = responses.reduce((final, current, index) => {
    final[Object.keys(endpoints)[index]] = current.data.results.map((item) => ({
      ...item,
      media_type: "movie",
    }));

    return final;
  }, {});

  return data;
};

export const getHomeTVs = async () => {
  const endpoints = {
    Trending: "/trending/tv/day",
    Popular: "/tv/popular",
    "Top Rated": "/tv/top_rated",
    Hot: "/trending/tv/day?page=2",
    "On the air": "/tv/on_the_air",
  };

  const responses = await Promise.all(
    Object.values(endpoints).map((endpoint) => axios.get(endpoint))
  );

  const data = responses.reduce((final, current, index) => {
    final[Object.keys(endpoints)[index]] = current.data.results.map((item) => ({
      ...item,
      media_type: "tv",
    }));

    return final;
  }, {});

  return data;
};

export const getMovieBannerInfo = async (movies) => {
  const detailRes = await Promise.all(
    movies.map((movie) => axios.get(`/movie/${movie.id}`))
  );

  const translationRes = await Promise.all(
    movies.map((movie) => axios.get(`/movie/${movie.id}/translations`))
  );

  const translations = translationRes.map((item) =>
    item.data.translations
      .filter((translation) =>
        ["vi", "fr", "ja", "pt", "ru", "es"].includes(translation.iso_639_1)
      )
      .reduce((acc, element) => {
        if (element.iso_639_1 === "fr") {
          return [element, ...acc];
        }
        return [...acc, element];
      }, [])
      .map((translation) => translation.data.title)
  );

  const genres = detailRes.map((item) => item.data.genres.slice(0, 3));

  return genres.map((genre, index) => ({
    genre,
    translation: translations[index],
  }));
};

export const getTVBannerInfo = async (tvs) => {
  const detailRes = await Promise.all(
    tvs.map((tv) => axios.get(`/tv/${tv.id}`))
  );

  const translationRes = await Promise.all(
    tvs.map((tv) => axios.get(`/tv/${tv.id}/translations`))
  );

  const translations = translationRes.map((item) =>
    item.data.translations
      .filter((translation) =>
        ["vi", "fr", "ja", "pt", "ru", "es"].includes(translation.iso_639_1)
      )
      .reduce((acc, element) => {
        if (element.iso_639_1 === "fr") {
          return [element, ...acc];
        }
        return [...acc, element];
      }, [])
      .map((translation) => translation.data.name)
  );

  const genres = detailRes.map((item) => item.data.genres.slice(0, 3));

  return genres.map((genre, index) => ({
    genre,
    translation: translations[index],
  }));
};

export const getTrendingNow = async () => {
  return (await axios.get("/trending/all/day?page=2")).data.results;
};

export const getMoviesGenresList = async () => {
  let moviesGenres = localStorage.getItem("moviesGenres")
    ? JSON.parse(localStorage.getItem("moviesGenres"))
    : null;

  if (!moviesGenres) {
    const genresRes = await axios.get("genre/movie/list");

    moviesGenres = {};
    genresRes?.data?.genres.forEach(({ id, name }) => {
      moviesGenres[id] = name;
    });
  }

  return moviesGenres;
};

export const getTVGenresList = async () => {
  let tvGenres = localStorage.getItem("tvGenres")
    ? JSON.parse(localStorage.getItem("tvGenres"))
    : null;

  if (!tvGenres) {
    const genresRes = await axios.get("genre/tv/list");

    tvGenres = {};
    genresRes?.data?.genres.forEach(({ id, name }) => {
      tvGenres[id] = name;
    });
  }

  return tvGenres;
};
